import { useContext } from "react";
import { ModalContext } from "./ModalProvider";
import styles from './DetailModal.module.css';
import { InnocodeButton } from "@intsoft/innocode-core";

/**
 * Modal Base Container
 * @param content
 * @param option
 * @returns {JSX.Element}
 * @constructor
 */
function DetailModal({ content, option, className = '' }) {

    const { closeModal } = useContext(ModalContext);

    return (
        <div className={`${styles.layer__popWrap}`}>
            <div className={`${styles.layer__popCont} ${styles.user} ${className}`}>
                <div className={`${styles.layer__popHeader} ${styles.detail}`}>                 {/* 모달 헤더 */}
                    <h1 className={`innocode-typography--headline-md innocode-typography--bold ${styles.contentAreaTitleText}`}>
                        {option.modalTitle}
                    </h1>
                    <InnocodeButton
                        theme={"opacity"}
                        designType='assistive'
                        enablePadding={false}
                        iconOnly={true}
                        icon={<svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18 17.94 6M18 18 6.06 6" />
                        </svg>
                        }
                        onClick={closeModal}
                    />
                </div>
                <div className={styles.layer__popDetail}>                                       {/* 모달 Content */}
                    {content}
                </div>

            </div>
        </div>
    )
}

export default DetailModal;